import { round } from 'lodash-es'
import { ImmutableVector3 } from '@modugen/ui-toolkit'

export interface Coordinates2D {
  x: number
  y: number
}

export const round2DCoordinates = (
  coordinates: Coordinates2D,
  numDecimals: number,
): Coordinates2D => {
  return {
    x: round(coordinates.x, numDecimals),
    y: round(coordinates.y, numDecimals),
  }
}

export const roundXYImmutableVector3 = (
  vector: ImmutableVector3,
  numDecimals: number,
): ImmutableVector3 => {
  return new ImmutableVector3(round(vector.x, numDecimals), round(vector.y, numDecimals), vector.z)
}

export const roundImmutableVector3 = (
  vector: ImmutableVector3,
  numDecimals: number,
): ImmutableVector3 => {
  return new ImmutableVector3(
    round(vector.x, numDecimals),
    round(vector.y, numDecimals),
    round(vector.z, numDecimals),
  )
}
